module.exports = __webpack_public_path__ + "img/monitor7.426ad7af.jpg";